<template>
  <div id="app" class="px-lg-5 px-md-4 px-1">
    <rd-samoobsluha-header/>
    <rd-samoobsluha-navbar v-if="$store.state.customerInfo"/>

    <!-- Upozorneni na neregistrovanou MAC adresu; odkaz s parametrem '?newMAC' je na blokovaci strance -->
    <section v-if="$store.state.newMacDetected" class="alert alert-warning upozorneni-pro-zakaznika">
      <div v-if="$store.state.customerInfo">
        <p>
          Vážený zákazníku, zaznamenali jsme připojení k síti Rychlý drát z nové, dozatím neregistrované MAC adresy <mark class="text-monospace">{{$store.state.newMacDetected}}</mark>.
          Pro přístup na internet je třeba <b>novou (změněnou) MAC adresu registrovat</b>. Změna je bezplatná a projeví se do 15 minut.
        </p>
        <p class="d-flex justify-content-between mt-4 mb-2" v-if="$router.currentRoute.name !== 'my-net-devices'">
          <button class="btn btn-info" @click="$router.push('/devices')">chci zaregistrovat novou MAC adresu</button>
          <button class="btn btn-outline-danger" @click="$store.commit('newMacDetected', false)">nedělat nic</button>
        </p>
      </div>
      <div v-else>
        <p>
          Vážený zákazníku, zaznamenali jsme připojení k síti Rychlý drát z nové, dozatím neregistrované MAC adresy <mark class="text-monospace">{{$store.state.newMacDetected}}</mark>.
          Pro přístup na internet je třeba <b>novou (změněnou) MAC adresu registrovat</b>. Změna je bezplatná a projeví se do 15 minut.
        </p>
        <p>
          Pro bezpečnost Vašich dat je nutné nejprve se přihlásit.
        </p>
      </div>
    </section>

    <!-- Upozorneni na nedoplatek -->
    <section v-if="$store.state.customerInfo && $store.state.cashTotals.overdue_amount > 0 && $router.currentRoute.name !== 'payment-finished'" class="alert alert-danger upozorneni-pro-zakaznika">
      <p>
        Dobrý den,
      </p>
      <p>
        vážíme si toho, že jste naším zákazníkem. Věříme, že došlo k nedopatření – na Vašem zákaznickém účtu evidujeme pohledávku po splatnosti.
      </p>
      <p>
        <b>Nedoplatek: {{prachy_bez_00($store.state.cashTotals.overdue_amount)}} Kč</b>
      </p>
      <p>
        Rádi bychom Vás požádali o kontrolu Vámi provedených plateb. Zkontrolujte si prosím i platební symboly (číslo účtu <span class="mutable">344355366</span>, kód banky <span class="mutable">2010</span>, variabilní symbol <span class="mutable">{{$store.state.customerInfo.id}}</span>).
        Pokud jste již platbu provedli dříve, informujte nás prosím o detailech provedené platby
        zasláním e-mailu na <a :href="`mailto:fakturace@rychlydrat.cz?subject=kontrola nedoplatku ${prachy_bez_00($store.state.cashTotals.overdue_amount)} Kč, zákazník VS=${$store.state.customerInfo.id}`">fakturace@rychlydrat.cz</a>.
      </p>
      <p v-if="$router.currentRoute.name !== 'my-account'">
        Předpisy plateb a evidované přijaté platby si můžete kdykoliv zkontrolovat <router-link to="/account">na stránce MŮJ ÚČET</router-link>.
      </p>
      <small>
        Rychlý drát, s.r.o.
      </small>
    </section>

    <br>

    <section v-if="maintenanceMode === true">
      <div class="media alert alert-warning p-5">
        <img class="mr-5" src="/static/rd-images/maintenance.png" width="200px" height="200px" alt="probíhá údržba"/>
        <div class="media-body">
          <h5 class="mt-0">Probíhá údržba</h5>
            Samoobsluha není v tuto chvíli dostupná. Právě pracujeme na údržbě systému. Zkuste to prosím za chvíli znovu.
        </div>
      </div>
    </section>
    <section v-if="maintenanceMode === false">
      <router-view
        @after-login="afterLogin()"
      />
    </section>

    <!-- hack jak zajistit konzistentní šířku všech stránek (moje služby vs můj účet vs doporuč) -->
    <p id="width-hack">
      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
    </p>
  </div>
</template>

<script>
import SessionResource from './backend-resources/session-resource'
import CashResource from './backend-resources/cash-resource'
import Header from '@/components/Header'
import Navbar from '@/components/Navbar'
import Login from '@/components/Login'

var sr = new SessionResource()

function getCookie (name) {
  var nameEQ = name + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

export default {
  name: 'app',
  components: {
    'rd-samoobsluha-header': Header,
    'rd-samoobsluha-navbar': Navbar,
    'login-component': Login
  },
  data: function () {
    return {
      maintenanceMode: undefined,
      loggedIn: false,
      newMacDetected: false
    }
  },
  methods: {
    async goToLoginIfUnauthorized () {
      sr.get().then((response) => {
        this.$store.commit('loginSuccess', response.data)
        this.loadCashOverdue()
        if (this.$router.currentRoute.path === '/') this.$router.push('/services')
      })
      .catch(() => {
        this.$router.push('/login')
      })
    },
    async afterLogin () {
      await this.loadCashOverdue()

      // Po přihlášení přesměrovat ...
      if (this.$router.currentRoute.query.agreement) {
        this.$router.push('/agreements') // ... na SMLOUVY, pokud je to odkaz "k podpisu smlouvy"
      } else if (this.$store.state.cashTotals.overdue_amount > 0) {
        this.$router.push('/account') // ... na MŮJ ÚČET, pokud mám dluh
      } else {
        this.$router.push('/services') // ... jinak na (první stránku) MOJE SLUŽBY
      }
    },
    async loadCashOverdue () {
      let cashTotals = await CashResource.get_overdue()
      this.$store.commit('setCashTotals', cashTotals.data)
    },
    prachy_bez_00: function (kolik) {
      if (kolik === null) return ''
      kolik = parseFloat(kolik)
      if (kolik.toFixed(2).endsWith('.00')) {
        return kolik.toFixed(0)
      } else {
        return kolik.toFixed(2)
      }
    },
    pingDb: function () {
      sr.pingDb().then(() => {
        this.maintenanceMode = false  // rozsvitit hlasku "udrzba"
      }).catch(() => {
        this.maintenanceMode = true
        setTimeout(this.pingDb, 60 * 1000) // cyklicky znova zkouset, az se to rozjede - hlasku "udrzba" sundat
      })
    }
  },
  created: function () {
    // presmerovani ze stranky "neregistrovana MAC adresa" (http://10.40.240.2:3000/)?
    if (this.$router.currentRoute.query['newMAC']) {
      if (this.$router.currentRoute.query['newMAC'].match(/^([0-9a-f]{2}:?){6}$/i)) {
        document.cookie = `RD-new-MAC-detected=${this.$router.currentRoute.query['newMAC']}; max-age=86400; path=/`
      }
    }
    const newMac = getCookie('RD-new-MAC-detected')
    if (newMac) this.$store.commit('newMacDetected', newMac)

    // Test, jestli je backend v provozu. Pokud ne, zobrazit "Probiha udrzba".
    this.pingDb()

    // Nejsme prihlaseni? -> presmerovat na /login
    if (this.$router.currentRoute.name == null || (!this.$router.currentRoute.name.startsWith('reset-password') && !this.$router.currentRoute.name.startsWith('login'))) {
      this.goToLoginIfUnauthorized()
    }
  },
  watch: {
    $route (to, from) {
      if (to.name !== 'login' && to.name !== 'logout' && to.name !== 'reset-password') {
        if (this.$store.state.customerInfo) this.loadCashOverdue()
      }
    }
  }
}
</script>

<style>
#app {
  margin: 0 auto;
  max-width: 1450px;
  color: black;
}

.upozorneni-pro-zakaznika {
  margin-top: 2em;
}
.error-box {
  color: red;
  border-color: red;
  border-width: 1px;
  border-style: solid;
  padding: 10px;
  background-color: yellow;
  border-radius: 0.25em;
}
.loading-spinner {
  text-align: center;
}
.mutable {
  color: darkblue;
}

</style>



// WEBPACK FOOTER //
// App.vue?2b2bf019